import { useCallback, useState } from "react";
import { listarEstudiantesPorPromocion } from "../../../../services/promocionesService";
import { showToast } from "../../../../utils/showToast";

export default function usePromocionInscritos() {
  const [inscritos, setInscritos] = useState([]);
  const [inscritosLoading, setInscritosLoading] = useState(false);

  const loadInscritos = useCallback(async (promocionId, options = {}) => {
    setInscritosLoading(true);
    try {
      const data = await listarEstudiantesPorPromocion(promocionId, options);
      setInscritos(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setInscritos([]);
      showToast({
        type: "danger",
        message: err.message || "No se pudieron cargar los inscritos.",
      });
      throw err;
    } finally {
      setInscritosLoading(false);
    }
  }, []);

  const resetInscritos = useCallback(() => {
    setInscritos([]);
    setInscritosLoading(false);
  }, []);

  return {
    inscritos,
    inscritosLoading,
    loadInscritos,
    resetInscritos,
  };
}
